module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("前端项目")]), _vm._v(" "), _c('el-form', _vm._l((_vm.projects), function(item, index) {
    return _c('div', {
      staticClass: "container"
    }, [_c('el-form-item', {
      attrs: {
        "label": "项目名称"
      }
    }, [_c('el-input', {
      attrs: {
        "value": item.name,
        "placeholder": "请填写项目名称"
      },
      on: {
        "change": function($event) {
          _vm.changeEditor({
            $event: $event,
            a: 'projects',
            b: 'name',
            index: index
          })
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "项目内容"
      }
    }, [_c('el-input', {
      attrs: {
        "value": item.content,
        "placeholder": "请填写项目内容"
      },
      on: {
        "change": function($event) {
          _vm.changeEditor({
            $event: $event,
            a: 'projects',
            b: 'content',
            index: index
          })
        }
      }
    })], 1), _vm._v(" "), (_vm.projects.length > 1) ? _c('i', {
      staticClass: "el-icon-circle-cross",
      on: {
        "click": function($event) {
          _vm.removeItem({
            a: 'projects',
            index: index
          })
        }
      }
    }) : _vm._e()], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f030d25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/ProjectEditor.vue
// module id = 197
// module chunks = 1